import {
  FormPageInputItem,
  FormPageInputItemNumber,
  FormPageInputItemNumberAdditionalText,
  INPUT_ITEM_TYPE,
  NumberProperty,
  NUMBER_PROPERTY_INPUT_TYPE,
} from 'shared';

const handleAdditionalText = (
  formPageInputItem?: FormPageInputItem
): FormPageInputItemNumberAdditionalText => {
  const inputItemType = INPUT_ITEM_TYPE.numberAdditionalText;
  if (
    formPageInputItem?.inputItemType === INPUT_ITEM_TYPE.numberAdditionalText
  ) {
    return {
      inputItemType,
      number: formPageInputItem.number ?? '',
    };
  }
  return {
    inputItemType,
    number: '',
  };
};

export const convertNumberInitialValue = (
  property: NumberProperty,
  formPageInputItem?: FormPageInputItem
): FormPageInputItemNumber => {
  switch (property.inputFormat.inputType) {
    case NUMBER_PROPERTY_INPUT_TYPE.additionalText: {
      return handleAdditionalText(formPageInputItem);
    }
  }
};
